import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e9fda8ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e9fda8ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fda8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9fda8ec')) {
      api.createRecord('e9fda8ec', component.options)
    } else {
      api.reload('e9fda8ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e9fda8ec&scoped=true", function () {
      api.rerender('e9fda8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/channelVolume/index.vue"
export default component.exports